import axios from 'axios';

// Función para obtener información del producto por ID
const CheckBackCode2f = async ({ backupCode, userId }) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.post(apiUrl, new URLSearchParams({
      type: 'checkBackupCode',
      backupcode: backupCode,
      userid: userId,
      responsetype: 'json',
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', 
        //'X-Requested-With': 'XMLHttpRequest'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching product info:', error);
    throw error;
  }
};

export default CheckBackCode2f;
